import React from 'react';

/**
 * Template 6: Process Flow
 * Person on right, step icons in grid with dashed arrow path.
 * Bold headline at top on colored highlight box.
 *
 * Inspired by: "LAY DOWN DEALS" with icon grid
 */

const ICON_MAP = {
  funnel: '\u{1F3AF}',    // target
  browser: '\u{1F4BB}',   // laptop
  email: '\u{2709}',      // envelope
  money: '\u{1F4B0}',     // money bag
  target: '\u{1F3AF}',    // bullseye
  play: '\u{25B6}',       // play button
  headset: '\u{1F3A7}',   // headphones
  chart: '\u{1F4C8}',     // chart
  people: '\u{1F465}',    // people
  star: '\u{2B50}',       // star
  check: '\u{2705}',      // check
  fire: '\u{1F525}',      // fire
};

export default function JH_ProcessFlow({
  headline = 'LAY DOWN DEALS',
  personImage,
  bgColor = '#F0F4F8',
  accentColor = '#FFD700',
  steps = [
    { icon: 'funnel', label: 'HIGH-INTENT FUNNEL' },
    { icon: 'browser', label: 'CONFIRM PAGE' },
    { icon: 'email', label: 'VALUE EMAILS' },
    { icon: 'money', label: 'PIF SALE' },
    { icon: 'target', label: 'DIAL MESSAGING' },
    { icon: 'play', label: 'RETARGET CONTENT' },
    { icon: 'headset', label: 'SETTERS OUTREACH' },
  ],
}) {
  const isLightBg = isLightColor(bgColor);
  const cols = steps.length <= 4 ? 2 : steps.length <= 6 ? 3 : 4;

  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Inter', sans-serif",
    }}>
      {/* Grid paper texture */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.06,
        backgroundImage: `linear-gradient(rgba(0,0,0,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.1) 1px, transparent 1px)`,
        backgroundSize: '40px 40px',
      }} />

      {/* Headline banner at top */}
      <div style={{
        position: 'absolute', top: 24, left: 40, zIndex: 3,
      }}>
        <span style={{
          display: 'inline-block', background: accentColor,
          padding: '6px 28px', fontSize: 56, fontWeight: 900,
          color: isLightColor(accentColor) ? '#111' : '#fff',
          textTransform: 'uppercase', letterSpacing: '-1px',
        }}>
          {headline}
        </span>
      </div>

      {/* Step icons grid - left/center */}
      <div style={{
        position: 'absolute', left: 40, top: 130, width: 740,
        display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: 16, zIndex: 1,
      }}>
        {steps.map((step, i) => (
          <div key={i} style={{
            background: '#E53935', borderRadius: 12, padding: '18px 14px',
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            gap: 8,
          }}>
            <div style={{ fontSize: 40 }}>
              {ICON_MAP[step.icon] || ICON_MAP.star}
            </div>
            <div style={{
              fontSize: 16, fontWeight: 700, color: '#fff',
              textAlign: 'center', textTransform: 'uppercase',
              lineHeight: 1.2,
            }}>{step.label}</div>
          </div>
        ))}
      </div>

      {/* Dashed arrow path (simplified) */}
      <svg style={{ position: 'absolute', left: 40, top: 130, width: 740, height: 560, zIndex: 0, pointerEvents: 'none' }}>
        <path
          d="M 100 60 Q 200 120, 300 60 Q 400 0, 500 60 Q 600 120, 700 60"
          fill="none" stroke={accentColor} strokeWidth="3" strokeDasharray="10,8"
          opacity="0.6"
        />
      </svg>

      {/* Person - right */}
      {personImage ? (
        <div style={{
          position: 'absolute', right: 0, bottom: 0, width: 480, height: 720, zIndex: 2,
        }}>
          <img src={personImage} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', right: 30, bottom: 0, width: 400, height: 600,
          background: isLightBg ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.06)',
          borderRadius: '12px 12px 0 0', zIndex: 2,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 36, color: isLightBg ? 'rgba(0,0,0,0.12)' : 'rgba(255,255,255,0.12)',
        }}>PHOTO</div>
      )}
    </div>
  );
}

function isLightColor(color) {
  const hex = (color || '#000').replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const toL = c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  return 0.2126 * toL(r) + 0.7152 * toL(g) + 0.0722 * toL(b) > 0.35;
}
